module.exports = __webpack_public_path__ + "static/media/301.2caf7fdb.png";